<p-toast></p-toast>

<chat *ngIf="showChatSideBar"
      [_showChatSideBar]="showChatSideBar"
      [_merchantId]="merchanUser.MerchantId"
      [_chatId]="merchanUser.ChatId"
      [_messageTypeId]="chatMessageTypeEnum.MerchantToSupport"
      (changedShowChatSideBarEmit)="changedShowChatSideBarEmit($event)"></chat>

<div [ngClass]="{'sidebar-active': app.sidebarActive}" class="flex">
    <!--<div>
        
    </div>-->
    <!-- width: calc(100vw - 410px);  -->
    <div class="sidebar-next-right-block">
        <div class="flex flex-row">
            <div class="col-2 w-18">
                <sidebar-menu>
                    <div class="sidebar-body pt-6">
                        <div class="onboarding-slider-menu" id="onboarding-slider-menu" *ngIf="activeMerchantStatus !== merchantStatusEnum.Activated">

                            <ul class="onboarding-slider-menu__list onboarding-slider-menu__list--theme-calypso" data-slider-menu="list">
                                <li class="onboarding-slider-menu__item" id="item-{{merchantStatusEnum.Sent}}">
                                    <a class="onboarding-slider-menu__link onboarding-slider-menu__link--theme-calypso"
                                       (click)="clickMenuLink(merchantStatusEnum.Sent)">Company Details</a>
                                </li>

                                <li class="onboarding-slider-menu__item" id="item-{{merchantStatusEnum.ApprovedCompanyDetail}}">
                                    <a class="onboarding-slider-menu__link onboarding-slider-menu__link--theme-calypso"
                                       (click)="clickMenuLink(merchantStatusEnum.ApprovedCompanyDetail)">Authorized Representative</a>
                                </li>

                                <li class="onboarding-slider-menu__item" id="item-{{merchantStatusEnum.ApprovedAuthorizedRepresentative}}">
                                    <a class="onboarding-slider-menu__link onboarding-slider-menu__link--theme-calypso"
                                       (click)="clickMenuLink(merchantStatusEnum.ApprovedAuthorizedRepresentative)">Documents</a>
                                </li>

                                <li class="onboarding-slider-menu__item" id="item-{{merchantStatusEnum.DocumentUploaded}}">
                                    <a class="onboarding-slider-menu__link onboarding-slider-menu__link--theme-calypso"
                                       (click)="clickMenuLink(merchantStatusEnum.DocumentUploaded)">Review Proposal</a>
                                </li>

                                <li class="onboarding-slider-menu__item" id="item-{{merchantStatusEnum.ForApproval}}">
                                    <a class="onboarding-slider-menu__link onboarding-slider-menu__link--theme-calypso"
                                       (click)="clickMenuLink(merchantStatusEnum.ForApproval)">Xpress Review</a>
                                </li>

                                <li class="onboarding-slider-menu__item" id="item-{{merchantStatusEnum.ForPartnerSignature}}">
                                    <a class="onboarding-slider-menu__link onboarding-slider-menu__link--theme-calypso"
                                       (click)="clickMenuLink(merchantStatusEnum.ForPartnerSignature)">Contract</a>
                                </li>
                            </ul>

                        </div>
                    </div>
                </sidebar-menu>
            </div>

            <div class="merchant-body col-10" [ngClass]="{
'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

                <div *ngIf="loading" style="text-align: center; padding: 30px;">
                    <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                                       fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
                </div>

                <div *ngIf="activeMerchantStatus === merchantStatusEnum.Sent && !loading">
                    <merchant-company-confirm [_showMerchantCompanyConfirmSideBar]="showMerchantCompanyConfirmSideBar" *ngIf="showMerchantCompanyConfirmSideBar"
                                              [merchantConfirmOnboardingComponent]="this" [_merchantCompany]="merchanUser"
                                              (changedShowMerchantCompanyConfirmSideBarEmit)="changedShowMerchantCompanyConfirmSideBarEmit($event)"></merchant-company-confirm>

                    <p-scrollPanel [style]="{height: 'calc(80vh)'}">
                        <div class="mco-header">
                            <div class="mco-header__title">Onboarding</div>
                        </div>

                        <!-- <div class="merchant-form-body">
                            <div class="merchant-form">
                                <div class="merchant-label">Registered company name (same as SEC document)</div>
                                <input type="text" [(ngModel)]="merchanUser.BusinessName" placeholder="Type here…" pInputText [disabled]="true" />
                            </div>

                            <div class="merchant-form">
                                <div class="merchant-label">Registered company address (same as SEC document)</div>
                                <input type="text" [(ngModel)]="merchanUser.BusinessAddress" placeholder="Address…" pInputText [disabled]="true" />
                            </div>

                            <div class="flex flex-row">
                                <div class="merchant-column merchant-column-50">
                                    <div class="merchant-form">
                                        <input type="text" [(ngModel)]="merchanUser.BusinessCity" placeholder="City" pInputText [disabled]="true" />
                                    </div>
                                </div>
                                <div class="merchant-column merchant-column-50">
                                    <div class="merchant-form">
                                        <input type="text" [(ngModel)]="merchanUser.BusinessPostalCode" placeholder="Zip Code" pInputText [disabled]="true" />
                                    </div>
                                </div>
                            </div>

                            <div class="merchant-form">
                                <div class="merchant-label">Trading name (what will be published in app)</div>
                                <input type="text" [(ngModel)]="merchanUser.TradingName" placeholder="Type here…" pInputText [disabled]="true" />
                            </div>

                            <div class="flex flex-row">
                                <div class="merchant-column merchant-column-50">
                                    <div class="merchant-form">
                                        <div class="merchant-label">Company Phone</div>
                                        <input type="text" [(ngModel)]="merchanUser.BusinessPhone" placeholder="+63" pInputText [disabled]="true" />
                                    </div>
                                </div>
                                <div class="merchant-column merchant-column-50">
                                    <div class="merchant-form">
                                        <div class="merchant-label">Company Email</div>
                                        <input type="text" [(ngModel)]="merchanUser.BusinessEmail" placeholder="Email" pInputText [disabled]="true" />
                                    </div>
                                </div>
                            </div>

                            <div class="merchant-form">
                                <div class="merchant-label">Please review the information on the left</div>
                                <div class="flex flex-row">
                                    <div *ngIf="merchanUser.MerchantStatus === merchantStatusEnum.New">
                                        <button pButton pRipple type="button" label="The details are correct" class="btn-blue"
                                                (click)="confirmMerchant(merchantStatusEnum.ApprovedCompanyDetail)"></button>
                                    </div>
                                    <div style="margin-left: 40px;">
                                        <button pButton pRipple type="button" label="Edit" class="btn-white" (click)="openMerchantCompanyConfirmSideBar()"></button>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <company-details 
                            [merchantUser]="merchanUser" 
                            [merchantUserTemp]="merchanUser" 
                            [merchantStatusEnum]="merchantStatusEnum"
                            (confirm)="confirmMerchant($event)"
                            
                            >
                        </company-details>
                    </p-scrollPanel>
                </div>

                <div *ngIf="activeMerchantStatus === merchantStatusEnum.ApprovedCompanyDetail && !loading">
                    <merchant-information-confirm [_merchant]="merchanUser" 
                                                [merchantConfirmOnboardingComponent]="this"
                                                (confirmMerchant)="confirmMerchant($event)"></merchant-information-confirm>
                </div>

                <merchant-upload-document [_showMerchantUploadDocumentSideBar]="showMerchantUploadDocumentSideBar"
                                          *ngIf="showMerchantUploadDocumentSideBar"
                                          [headerTitleText]="headerUploadDocumentTitleText"
                                          [merchantConfirmOnboardingComponent]="this" [_merchant]="merchanUser"
                                          [_activeMerchantUploadDocumentType]="activeMerchantUploadDocumentType"
                                          [_isRejectedDocument]="isRejectedDocument"
                                          (changedShowMerchantUploadDocumentSideBarEmit)="changedShowMerchantUploadDocumentSideBarEmit($event)"></merchant-upload-document>

                <div *ngIf="activeMerchantStatus === merchantStatusEnum.ApprovedAuthorizedRepresentative && !loading">
                    <div class="mco-header mt-4">
                        <div class="mco-header__title mb-4">Documents</div>
                    </div>
                    <div class="flex flex-row merchant-label-box mb-3">
                        <img class="onboarding-img" src="/XpressApp/assets/images/partner/onboarding/info-onboarding.png">
                        Accepted file formats are .jpg and .png with a maximum file size of 5MB.
                    </div>
                    <div class="flex flex-row onboarding-header-menu mt-3">
                        <div class="onboarding-header-menu-link"
                             [class]="(activeDocumentsMenuEnum === documentsMenuEnum.CompanyDocuments) ? 'active-ohml' : ''"
                             (click)="changeActiveDocumentsMenuEnum(documentsMenuEnum.CompanyDocuments)">Company Documents</div>
                        <div class="onboarding-header-menu-link"
                             [class]="(activeDocumentsMenuEnum === documentsMenuEnum.AuthorizedRepresentativeDocuments) ? 'active-ohml' : ''"
                             (click)="changeActiveDocumentsMenuEnum(documentsMenuEnum.AuthorizedRepresentativeDocuments)">Authorized Representative Documents</div>
                    </div>

                    <p-scrollPanel [style]="{height: 'calc(100vh - 220px)'}">
                        <div class="flex flex-row" *ngIf="activeDocumentsMenuEnum === documentsMenuEnum.CompanyDocuments">
                            <div class="merchant-column-50 mud-mr-30px">
                                <div class="mco-upload-block">
                                    <div class="xpress-review-revision__text fw-600">SEC or DTI Certificate</div>
                                    <div class="mco-upload-block__btn" *ngIf="merchanUser.SECDocumentImageUrl === ''">
                                        <button mat-button
                                                color="primary"
                                                class="reupload-btn"
                                                (click)="openMerchantUploadDocumentSideBar('SEC or DTI Certificate', merchantUploadDocumentTypeEnum.SECDocuments, documentStatusEnum.Rejected)">
                                                <mat-icon>upload</mat-icon>Upload
                                        </button>
                                    </div>
                                    <div class="flex flex-row" *ngIf="merchanUser.SECDocumentImageUrl !== ''">
                                        <div class="merchant-column-50">
                                            <div class="mud-view-document-block mb-3">
                                                <p-galleria [value]="[merchanUser.SECDocumentImageUrl]" [containerStyle]="{ 'max-width': '640px' }" [showThumbnailNavigators]="false" [showThumbnails]="false">
                                                    <ng-template pTemplate="item" let-item>
                                                        <img [src]="item" style="width: 100%; display: block;" />
                                                    </ng-template>
                                                    <ng-template pTemplate="caption" let-item>
                                                        <h4 style="margin-bottom: .5rem; color: #ffffff;">{{ 'Doc. No.: ' + merchanUser.SECDocumentNumber}}</h4>
                                                        <p>{{ 'Issued Date: ' +  merchanUser.SECDocumentIssueDate}}</p>
                                                    </ng-template>
                                                </p-galleria>
                                            </div>
                                            <button mat-button
                                                color="primary"
                                                class="reupload-btn mr-3"
                                                (click)="openMerchantUploadDocumentSideBar('SEC or DTI Certificate', merchantUploadDocumentTypeEnum.SECDocuments, documentStatusEnum.Rejected)">
                                                    <mat-icon>upload</mat-icon>Reupload
                                            </button>
                                            <button mat-button
                                                color="primary"
                                                class="delete-btn"
                                                (click)="deleteDocument(1)">
                                                    <mat-icon>delete</mat-icon>Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="merchant-column-50 mud-mr-30px">
                                <div class="mco-upload-block">
                                    <div class="xpress-review-revision__text fw-600">BIR 2303 Document</div>
                                    <div class="mco-upload-block__btn" *ngIf="merchanUser.BIR2303DocumentImageUrl === ''">
                                        <button mat-button
                                                color="primary"
                                                class="reupload-btn"
                                                (click)="openMerchantUploadDocumentSideBar('BIR 2303 Document', merchantUploadDocumentTypeEnum.BIR2303Document, documentStatusEnum.Rejected)">
                                                <mat-icon>upload</mat-icon>Upload
                                        </button>
                                    </div>
                                    <div class="flex flex-row" *ngIf="merchanUser.BIR2303DocumentImageUrl !== ''">
                                        <div class="merchant-column-50">
                                            <div class="mud-view-document-block mb-3">
                                                <p-galleria [value]="[merchanUser.BIR2303DocumentImageUrl]" [containerStyle]="{ 'max-width': '640px' }" [showThumbnailNavigators]="false" [showThumbnails]="false">
                                                    <ng-template pTemplate="item" let-item>
                                                        <img [src]="item" style="width: 100%; display: block;" />
                                                    </ng-template>
                                                    <ng-template pTemplate="caption" let-item>
                                                        <h4 style="margin-bottom: .5rem; color: #ffffff;">{{ 'Doc. No.: ' + merchanUser.BIR2303DocumentNumber}}</h4>
                                                        <p>{{ 'Issued Date: ' +  merchanUser.BirDateIssue}}</p>
                                                    </ng-template>
                                                </p-galleria>
                                            </div>
                                            <button mat-button
                                                color="primary"
                                                class="reupload-btn"
                                                (click)="openMerchantUploadDocumentSideBar('BIR 2303 Document', merchantUploadDocumentTypeEnum.BIR2303Document, documentStatusEnum.Rejected)">
                                                <mat-icon>upload</mat-icon>Reupload
                                            </button>
                                            <button mat-button
                                                color="primary"
                                                class="delete-btn"
                                                (click)="deleteDocument(2)">
                                                    <mat-icon>delete</mat-icon>Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-row" *ngIf="activeDocumentsMenuEnum === documentsMenuEnum.AuthorizedRepresentativeDocuments">
                            <div class="merchant-column-50 mud-mr-30px">
                                <div class="mco-upload-block">
                                    <div class="xpress-review-revision__text fw-600">Special Power of Attorney (SPA)</div>
                                    <div class="mco-upload-block__btn" *ngIf="merchanUser.CompanyAuthorizationLetterImageUrl === ''">
                                        <button mat-button
                                                color="primary"
                                                class="reupload-btn"
                                                (click)="openMerchantUploadDocumentSideBar('Special Power of Attorney (SPA)', merchantUploadDocumentTypeEnum.CompanyAuthorizationLetter, documentStatusEnum.Rejected)">
                                                <mat-icon>upload</mat-icon>Upload
                                        </button>
                                    </div>
                                    <div class="flex flex-row" *ngIf="merchanUser.CompanyAuthorizationLetterImageUrl !== ''">
                                        <div class="merchant-column-50">
                                            <div class="mud-view-document-block mb-3">
                                                <p-galleria [value]="[merchanUser.CompanyAuthorizationLetterImageUrl]" [containerStyle]="{ 'max-width': '640px' }" [showThumbnailNavigators]="false" [showThumbnails]="false">
                                                    <ng-template pTemplate="item" let-item>
                                                        <img [src]="item" style="width: 100%; display: block;" />
                                                    </ng-template>
                                                    <ng-template pTemplate="caption" let-item>
                                                        <h4 style="margin-bottom: .5rem; color: #ffffff;">{{ 'Issued Date: ' + merchanUser.CompanyAuthorizationLetterIssueDate}}</h4>
                                                    </ng-template>
                                                </p-galleria>
                                            </div>
                                            <button mat-button
                                                color="primary"
                                                class="reupload-btn"
                                                (click)="openMerchantUploadDocumentSideBar('Special Power of Attorney (SPA)', merchantUploadDocumentTypeEnum.CompanyAuthorizationLetter, documentStatusEnum.Rejected)">
                                                <mat-icon>upload</mat-icon>Reupload
                                            </button>
                                            <button mat-button
                                                color="primary"
                                                class="delete-btn"
                                                (click)="deleteDocument(4)">
                                                    <mat-icon>delete</mat-icon>Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="merchant-column-50 mud-mr-30px">
                                <div class="mco-upload-block">
                                    <div class="xpress-review-revision__text fw-600">Valid ID</div>
                                    <div class="mco-upload-block__btn" *ngIf="merchanUser.PersonalIdentificationImageUrl === ''">
                                        <button mat-button
                                                color="primary"
                                                class="reupload-btn"
                                                (click)="openMerchantUploadDocumentSideBar('Valid ID', merchantUploadDocumentTypeEnum.PersonalIdentification, documentStatusEnum.Rejected)">
                                                <mat-icon>upload</mat-icon>Upload
                                        </button>
                                    </div>
                                    <div class="flex flex-row" *ngIf="merchanUser.PersonalIdentificationImageUrl !== ''">
                                        <div class="merchant-column-50">
                                            <div class="mud-view-document-block mb-3">
                                                <p-galleria [value]="[merchanUser.PersonalIdentificationImageUrl]" [containerStyle]="{ 'max-width': '640px' }" [showThumbnailNavigators]="false" [showThumbnails]="false">
                                                    <ng-template pTemplate="item" let-item>
                                                        <img [src]="item" style="width: 100%; display: block;" />
                                                    </ng-template>
                                                    <ng-template pTemplate="caption" let-item>
                                                        <h4 style="margin-bottom: .5rem; color: #ffffff;">{{ merchanUser.PersonalIdTypeText}}</h4>
                                                        <p>{{ 'Expiration Date: ' +  merchanUser.PersonalIdentificationExpirationDate}}</p>
                                                    </ng-template>
                                                </p-galleria>
                                            </div>
                                            <button mat-button
                                                color="primary"
                                                class="reupload-btn"
                                                (click)="openMerchantUploadDocumentSideBar('Valid ID', merchantUploadDocumentTypeEnum.PersonalIdentification, documentStatusEnum.Rejected)">
                                                <mat-icon>upload</mat-icon>Reupload
                                            </button>
                                            <button mat-button
                                                color="primary"
                                                class="delete-btn"
                                                (click)="deleteDocument(3)">
                                                    <mat-icon>delete</mat-icon>Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="merchant-submited-block"
                             *ngIf="merchanUser.SECDocumentImageUrl !== '' && merchanUser.BIR2303DocumentImageUrl !== '' &&
                     merchanUser.PersonalIdentificationImageUrl !== '' && merchanUser.CompanyAuthorizationLetterImageUrl !== ''">
                            <div class="flex flex-row">
                                <div *ngIf="merchanUser.MerchantStatus === merchantStatusEnum.ApprovedAuthorizedRepresentative">
                                    <button pButton pRipple type="button" label="Submited" class="btn-blue"
                                            (click)="confirmMerchant(merchantStatusEnum.DocumentUploaded)"></button>
                                </div>
                            </div>
                        </div>
                    </p-scrollPanel>
                </div>

                <div *ngIf="activeMerchantStatus === merchantStatusEnum.DocumentUploaded && !loading">
                    <p-scrollPanel [style]="{height: 'calc(100vh - 220px)'}">
                        <div class="review-proposal-title">Our partnership proposal</div>
                        <div class="review-proposal-subtitle">It is with great pleasure that we propose our partnership with the following commercial terms.</div>

                        <div class="flex flex-row review-proposal-body">
                            <div class="review-proposal-column50">
                                <!-- Review Proposal Detail -->
                                <div class="formgrid grid">
                                    <div class="field col">
                                        <p class="pl-12">Partner Stores:</p>
                                    </div>
                                    <div class="field col">
                                        <p>3</p>
                                    </div>
                                </div>
                                <div class="formgrid grid">
                                    <div class="field col">
                                        <p>Service:</p>
                                    </div>
                                    <div class="field col">
                                        <p>Xpress Eats</p>
                                    </div>
                                </div>
                                <div class="formgrid grid">
                                    <div class="field col">
                                        <p>Category:</p>
                                    </div>
                                    <div class="field col">
                                        <p>Delivery + Pick-up</p>
                                    </div>
                                </div>
                                <div class="partnership-title">
                                    Partnership Agreement
                                </div>
                                <p class="odd-agreement agreement-style">Delivery orders processed through the Xpress platform:</p>
                                <p class="even-agreement agreement-style">18% + VAT</p>
                                <p class="odd-agreement agreement-style">Pickup orders processed through the Xpress platform:</p>
                                <p class="even-agreement agreement-style">6% + VAT</p>
                                <div class="partnership-title">
                                    Additional
                                </div>
                                <p class="odd-agreement agreement-style">Promo:</p>
                                <p class="even-agreement agreement-style">First 30 days at 5% + VAT</p>
                                <p class="odd-agreement agreement-style">Advertising:</p>
                                <p class="even-agreement agreement-style">P10,000 Xpress advertising credits</p>

                            </div>
                            <div class="review-proposal-column50">
                                <div class="review-proposal-contract">
                                    <p>
                                        The proposed partnership terms are valid for 15 days from the start of this proposal,
                                        if this period lapses, the partnership terms will need to be reviewed by Xpress.
                                    </p>

                                    <p>
                                        If you agree to this proposal, please click confirm below, if you have a question about these terms,
                                        please submit a ticket using the button below and your Message will be delivered to the account manager.
                                    </p>

                                    <p>
                                        By agreeing to the proposal, you are agreeing that the details you have provided are true and accurate and that your agree with the proposed terms of the partnership.
                                        This information will be submitted to Xpress for confirmation purposes, which will enable us to generate a contract.
                                    </p>

                                    <p>
                                        <b class="review-proposal-field-bold">This proposal does not constitute a binding contract.</b>
                                    </p>
                                </div>

                                <div class="field-checkbox review-proposal-field-checkbox">
                                    <mat-checkbox [(ngModel)]="reviewProposalCheckBox" color="primary"></mat-checkbox>
                                    <label for="contact">The details I provided are true and accurate</label>
                                </div>

                                <div class="review-proposal-column-btn-bottom-block">
                                    <button mat-flat-button color="primary"
                                            *ngIf="merchanUser.MerchantStatus === merchantStatusEnum.DocumentUploaded"
                                            (click)="confirmMerchant(merchantStatusEnum.ForApproval)">Confirm Proposal Details</button>
                                    <!-- <button pButton pRipple type="button" label="Confirm Proposal Details" class="contact-btn-blue"
                                            *ngIf="merchanUser.MerchantStatus === merchantStatusEnum.DocumentUploaded"
                                            (click)="confirmMerchant(merchantStatusEnum.ApprovedProposal)"></button> -->
                                    <button mat-button
                                            color="primary"
                                            class="p-button-outlined p-button-secondary contact-btn-outliner-secondary ml-3"
                                            (click)="openChatSideBar()">I have a question</button>
                                </div>
                            </div>
                        </div>
                    </p-scrollPanel>
                </div>

                <div *ngIf="activeMerchantStatus === merchantStatusEnum.ForApproval && !loading">

                    <div class="xpress-review-block" *ngIf="merchanUser.RejectReasonId !== rejectReasonEnum.RejectDocument">
                        <div class="xpress-review-body">
                            <div class="flex flex-row">
                                <div class="xpress-review-column-50">
                                    <div class="xpress-review-title">Xpress Review</div>
                                    <div class="xpress-review-text">
                                        Thank you for agreeing to the proposed partnership agreement, we have received your documents and in the process of preparing your contract, if everything is in order this process usually takes a few hours.
                                        <br /><br />
                                        We will send you an email when your contract is ready!
                                    </div>
                                    <div class="xpress-review-question-btn-block">
                                        <button pButton pRipple type="button" label="I have a question"
                                                class="p-button-outlined p-button-secondary"
                                                (click)="openChatSideBar()"></button>
                                    </div>
                                </div>
                                <div class="xpress-review-column-50">
                                    <img class="xpress-review-img" src="/XpressApp/assets/images/merchant/xpress_review_merchant.svg" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="xpress-review-document-block" *ngIf="merchanUser.RejectReasonId === rejectReasonEnum.RejectDocument">
                        <div class="flex flex-row">
                            <div class="xpress-review-column-50">
                                <div class="xpress-review-title">Xpress Review</div>
                                <div class="xpress-review-revision">
                                    <div class="xpress-review-revision__title">For Revision</div>
                                    <div class="xpress-review-revision__text">
                                        We found a few problems with your details, click below to fix the issues
                                    </div>
                                    <div>
                                        <a class="xpress-review-revision__link-document" *ngIf="merchanUser.SECDocumentStatusId !== documentStatusEnum.Approved">
                                            <span class="revision-link-block" [ngClass]="(merchanUser.SECDocumentStatusId === documentStatusEnum.Rejected) ? 'xpress-review-revision__link-dark-blue' : 'xpress-review-revision__link-green'"
                                                  (click)="openMerchantUploadDocumentSideBar('Upload SEC Documents', merchantUploadDocumentTypeEnum.SECDocuments, merchanUser.SECDocumentStatusId)">
                                                  <img class="check-img" src="/XpressApp/assets/images/check.svg" *ngIf="(merchanUser.SECDocumentStatusId !== documentStatusEnum.Rejected)" /> Link 1
                                            </span>
                                        </a>
                                        <br />
                                        <a class="xpress-review-revision__link-document" *ngIf="merchanUser.BIR2303DocumentStatusId !== documentStatusEnum.Approved">
                                            <span class="revision-link-block" [ngClass]="(merchanUser.BIR2303DocumentStatusId === documentStatusEnum.Rejected) ? 'xpress-review-revision__link-dark-blue' : 'xpress-review-revision__link-green'"
                                                  (click)="openMerchantUploadDocumentSideBar('Upload BIR 2303 Document', merchantUploadDocumentTypeEnum.BIR2303Document, merchanUser.BIR2303DocumentStatusId)">
                                                  <img class="check-img" src="/XpressApp/assets/images/check.svg" *ngIf="(merchanUser.BIR2303DocumentStatusId !== documentStatusEnum.Rejected)" /> Link 2
                                            </span>
                                        </a>
                                        <br />
                                        <a class="xpress-review-revision__link-document" *ngIf="merchanUser.PersonalIdentificationStatusId !== documentStatusEnum.Approved">
                                            <span class="revision-link-block" [ngClass]="(merchanUser.PersonalIdentificationStatusId === documentStatusEnum.Rejected) ? 'xpress-review-revision__link-dark-blue' : 'xpress-review-revision__link-green'"
                                                  (click)="openMerchantUploadDocumentSideBar('Upload Personal Identification', merchantUploadDocumentTypeEnum.PersonalIdentification, merchanUser.PersonalIdentificationStatusId)">
                                                  <img class="check-img" src="/XpressApp/assets/images/check.svg" *ngIf="(merchanUser.PersonalIdentificationStatusId !== documentStatusEnum.Rejected)" /> Link 3
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="xpress-review-column-50">
                                <img class="xpress-review-img" src="/XpressApp/assets/images/merchant/xpress_review_merchant.svg" />
                            </div>
                        </div>
                        <div class="xpress-review-document-footer">
                            <button pButton pRipple type="button" label="Submit" class="contact-btn-blue"
                                    (click)="confirmMerchant(merchantStatusEnum.ForApproval)"
                                    [disabled]="isRejectedDocument"></button>
                        </div>
                    </div>

                </div>

                <merchant-sign-contract *ngIf="activeMerchantStatus === merchantStatusEnum.ForPartnerSignature && !loading"
                                        [merchanUser]="merchanUser"
                                        (changedMerchantSignContractEmit)="changedMerchantSignContractEmit($event)"></merchant-sign-contract>
            </div>
        </div>

        
    </div>
</div>
